import { NavigationProps } from '@sola/schema/lib/schema.js';

export const getMenuItemColumns = (i: NavigationProps) => {
  const columns: [NavigationProps[], NavigationProps[], NavigationProps[]] = [
    [],
    [],
    [],
  ];

  let currentColumn = 0;
  let itemCount = 0;
  let containsLargeItem = false;
  let partialColumn = false;
  i.items?.forEach((item: NavigationProps) => {
    // this item has children
    if (item.items?.length) {
      // is it large enough to need its own row?
      const needsOwnRow =
        (item.items?.length > 3 && item.displayVariant !== 'grid') ||
        (item.items?.length > 6 && item.displayVariant === 'grid');

      // if we already have a partially filled column and the current item needs its own row
      // then we bump the column count, reset item count and partial column flag
      if (partialColumn && needsOwnRow) {
        currentColumn++;
        itemCount = 0;
        partialColumn = false;
      } else {
        // if the item doesn't need its own row, we need to know how many smaller items can fit
        containsLargeItem = true;
      }

      // place the item in the column and increment the item
      columns[currentColumn % 3].push(item);
      partialColumn = true;
      itemCount++;

      // if this item was big enough to need its own row, move to the next column
      if (needsOwnRow || itemCount >= 2) {
        currentColumn++;
        itemCount = 0;
        partialColumn = false;
        containsLargeItem = false;
      }
    } else {
      // we have a smaller item with no children
      // push to the column stack and bump the item count
      columns[currentColumn % 3].push(item);
      itemCount++;

      // by adding an item to this column, we now have a partially filled column
      partialColumn = true;

      // if we have more than 3 smaller items or 2 items where at least 1 is large
      // then bump the column count and move to the next column
      if (itemCount >= 3 || (containsLargeItem && itemCount >= 2)) {
        partialColumn = false;
        currentColumn++;
        itemCount = 0;
        containsLargeItem = false;
      }
    }
  });

  return columns;
};
